// action - state management
import { SET_GIS_CONFIG_ID, SET_GIS_CONFIGS, CLEAR_GIS_CONFIGS } from './actions';

export const initialState = {
    currentConfigId:null,
    gisDataConfigs:[]
};

//-----------------------|| ACCOUNT REDUCER ||-----------------------//

const gisDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_GIS_CONFIG_ID: {
            const { id } = action.payload;
            return {
                ...state,
                currentConfigId: id
            };
        }
        case SET_GIS_CONFIGS: {
            const { configs } = action.payload;
            return {
                ...state,
                gisDataConfigs: configs
            };
        }
        case CLEAR_GIS_CONFIGS: {
            // const { id } = action.payload;
            return {
                ...state,
                currentConfigId: null,
                gisDataConfigs: []
            };
        }
        default: {
            return { ...state };
        }
    }
};

export default gisDataReducer;
